import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import Services from './services/service-provider/Services';
import Head from "../src/components/head/Head"
import { LicenseInfo } from '@mui/x-license';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
LicenseInfo.setLicenseKey('e7eba9c9a0593bd3a4b68be6b5abdeb6Tz0xMTgyMzYsRT0xNzg3ODc1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
root.render(
  <React.StrictMode>
    <Router>
    <Services>
      <Head/>
      <App/>
    </Services>
    </Router>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
